module.exports = __webpack_public_path__ + "static/media/tag_yellow.440f48e7.svg";